import styled from 'styled-components';
export const Container = styled.div`
  width: 100%;
  padding: 12px 30px 12px 30px;
  box-sizing: border-box;
  font-weight: 400;
  font-size: 14px;
  &:hover {
    background: #f2f2f2;
  }
`;
export const IconWrapper = styled.div`
  display: inline-block;
  vertical-align: middle;
  width: 30px;
  text-align: center;
  margin-right: 10px;
`;
